<template>
  <div id="app">
    <el-main class="main" style="padding: 0">
      <router-view></router-view>
    </el-main>
  </div>
</template>

<script>
export default {
  name: "Settings"
};
</script>

<style>
#app {
  height: 100%;
}
.main {
  height: 100%;
  padding: 0;
}
</style>
